import PurchaseCart from "@tw/purchase-cra/lib/components/cart/cart-master-nextjs";
import PageWrapper from "../wrappers/page-wrapper";

PurchaseCart.domainName = "purchase-cart";

export default PageWrapper(PurchaseCart);
